import { gsap } from "gsap";

const DownloadPDF = () => {
  gsap.utils.toArray("[data-pdf]").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      let id = btn.dataset.submissionId;
      let name = btn.dataset.submissionName;
      let url = `/wp-admin/admin-ajax.php?action=ajax_pdf_renderer&submission_id=${id}`;
      fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      })
        .then((response) => {
          return response.blob();
        })
        .then((blob) => {
          (a = document.createElement("a")), (d = new Date());
          a.href = window.URL.createObjectURL(blob);
          a.download = `review-${name}-${d.getTime()}.pdf`;
          a.click();
        })
        .catch((error) => {
          console.error("Global Error Handler:", error);
        });
    });
  });
};

export { DownloadPDF };
